import { render } from "./KanoonInstituteListCard.vue?vue&type=template&id=5698af88"
import script from "./KanoonInstituteListCard.vue?vue&type=script&lang=js"
export * from "./KanoonInstituteListCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"KanoonInstituteListCard.vue"]])

export default __exports__